import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { displaySnackBar } from '../features/snackbar'
import { useAppDispatch } from './storeHooks'

export const useCopyToClipboard = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const copyToClipboard = useCallback(
    (url?: string) => {
      const location = url ? url : window.location.href
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(location)
        const NOTIFY_TEXT = t('common:notify_url_copied_clipboard')
        dispatch(displaySnackBar({ message: NOTIFY_TEXT, severity: 'success', open: true }))
      } else {
        // Fallback for local development or non-secure contexts
        const textArea = document.createElement('textarea')
        textArea.value = location
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        try {
          const successful = document.execCommand('copy')
          if (successful) {
            const NOTIFY_TEXT = t('common:notify_url_copied_clipboard')
            dispatch(displaySnackBar({ message: NOTIFY_TEXT, severity: 'success', open: true }))
          } else {
            dispatch(displaySnackBar({ message: t('common:notify_url_not_copied_clipboard'), severity: 'error', open: true }))
          }
        } catch (err) {
          dispatch(displaySnackBar({ message: t('common:notify_url_not_copied_clipboard'), severity: 'error', open: true }))
        }

        document.body.removeChild(textArea)
      }
    },
    [dispatch, t]
  )
  return copyToClipboard
}
